module.exports = __webpack_public_path__ + "static/media/shareLockGuide1_Jap.d2511381.jpg";